<template>
    <el-card class="fitness-index">
        <!-- 筛选 -->
        <el-form
            label-width="0px"
            label-position="right"
            class="w-full flex flex-wrap items-center">
            <el-form-item style="width:160px">
                <el-select
                    v-model="form.storeId"
                    :placeholder="$t('Common.all_store2')"
                    class="w-full" clearable>
                    <el-option
                        v-for="(item, index) in stores"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                    />
                </el-select>
            </el-form-item>
            <el-form-item style="width:120px">
                <el-select
                    v-model="form.followTypeCode"
                    :placeholder="$t('Common.all_type')"
                    class="w-full"
                    clearable>
                    <el-option
                        v-for="(item, index) in constant.followType"
                        :key="index"
                        :label="item.name"
                        :value="item.code"
                    />
                </el-select>
            </el-form-item>
            <el-form-item style="width:160px">
                <el-select
                    v-model="form.followResultCode"
                    :placeholder="$t('Client.communication_result')" class="w-full" clearable>
                    <el-option
                        v-for="(item, index) in constant.followResult"
                        :key="index"
                        :label="item.name"
                        :value="item.code"
                    />
                </el-select>
            </el-form-item>
            <el-form-item style="width:120px">
                <el-select
                    v-model="form.clientTypeCode"
                    :placeholder="$t('Client.allclient')" class="w-full" clearable>
                    <el-option
                        v-for="(item, index) in constant.clientType"
                        :key="index"
                        :label="item.name"
                        :value="item.code"
                    />
                </el-select>
            </el-form-item>
            <el-form-item style="width:180px">
                <el-select
                    @change="searchStaff = null"
                    v-model="form.followStaffId"
                    :placeholder="$t('Client.allflowup')"
                    class="w-full relative" clearable>
                    <input
                        type="text"
                        class="search-input-all"
                        v-model="searchStaff"/>
                    <el-option
                        v-for="(item, index) in filterStaff"
                        :key="index"
                        :label="item.nickname"
                        :value="item.id"
                        :disabled="item.id === 'no'"
                    />
                </el-select>
            </el-form-item>
            <el-form-item class="el-input--small">
                <el-date-picker
                    v-model="date"
                    style="width: 330px"
                    type="daterange"
                    range-separator="-"
                    :start-placeholder="$t('Client.flowup_starttime')"
                    :end-placeholder="$t('Client.flowup_Endtime')"
                    value-format="yyyy-MM-dd"
                />
            </el-form-item>
            <el-form-item style="width:300px">
                <el-button type="primary" @click="fetchData">{{ $t('Common.screen') }}</el-button>
                <el-button @click="handleReset">{{ $t('Common.clear') }}</el-button>
            </el-form-item>
        </el-form>
        <p>{{ $t('Charge.search2') }}{{pagination.total}}{{ $t('Client.record') }}</p>
        <el-table border v-if="tableData" :data="tableData" class="my-4" v-loading="loading">
            <!-- <el-table-column prop="clientId" :label="$t('Card.client_id')" width="80px"/> -->
            <el-table-column prop="storeName" :label="$t('Common.store')" />
            <el-table-column prop="followType" :label="$t('Client.flowup_type')" />
            <el-table-column prop="createdAt" :label="$t('Member.Follow.time')" />
            <el-table-column prop="followStaffNickname" :label="$t('Member.Follow.people')" />
            <el-table-column prop="clientName" :label="$t('Card.client_name')">
                <template slot-scope="{row}">
                    <span
                        @click="handleClient(row)"
                        class="task-workers cursor-pointer">{{ row.clientName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="clientType" width="100px" :label="$t('Client.type')" />
            <el-table-column prop="followResult" :label="$t('Client.communication_result')" />
            <el-table-column prop="remark" :label="$t('Client.follow_remark')" width="400%" />
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-center"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
    </el-card>
</template>

<script>
import { Dialog, DatePicker } from 'element-ui';
import filterRole from '@/mixins/filterRole.js';

export default {
    props: ['activeName', 'clientId'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
    },
    mixins: [filterRole],
    data() {
        return {
            constant: [],
            stores: [],
            date: [],
            staffs: [],
            form: {
                authorizedStoreIds: [],
                storeId: '',
                followTypeCode: '',
                followStaffId: '',
                followResultCode: '',
                clientTypeCode: '',
                createdAtStart: '',
                createdAtEnd: '',
                page: 1,
            },
            totalCount: 0,
            potentialClientCount: 0,
            fullPercent: '',
            fullClientCount: 0,
            loading: false,
            tableData: [],
            clientIds: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            is_collapse: false,
            searchStaff: null,
        };
    },
    computed: {
        filterStaff() {
            if (!this.searchStaff) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchStaff.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    watch: {
        activeName(val) {
            if (val === 'eighth') {
                this.fetchData();
                this.fetchStore();
                this.fetchConstant();
                this.fetchStaff();
            }
        },
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            if (this.date.length) {
                this.form = {
                    createdAtStart: this.date[0],
                    createdAtEnd: this.date[1],
                };
            }
            API.get('client/follow-record', {
                params: { ...this.form },
            })
            .then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        say() {
            this.fetchData();
        },
        handleReset() {
            this.form = {};
            this.date = [];
            this.fetchData(1);
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchConstant() {
            this.loading = true;
            API.get('constant/client/follow')
            .then(res => {
                this.constant = res;
            })
            .finally(() => {
                this.loading = false;
            })
            .catch(err => {
                $ele.$message.error(err);
            });
        },
        async fetchStaff() {
            this.loading = true;
            this.staffs = await this.filterRole();
            this.loading = false;
        },
        handleClient(row) {
            const activeName = row.clientTypeCode === 1 ? 'first' : 'second';
            const id = row.clientId;
            this.$emit('update:activeName', activeName);
            this.$emit('update:clientId', id);
            this.$emit('input', 'update');
        },
    },
    created() {
        if (this.activeName === 'eighth') {
            this.fetchData();
            this.fetchStore();
            this.fetchConstant();
            this.fetchStaff();
        }
    },
};
</script>
<style lang="scss">
.title {
    width: 98%;
}
.title-3a {
    height: 30px;
    color: grey;
    line-height: 50px;
    font-size: 12px;
    font-weight: 400;
}
.search-divpp {
    position: absolute !important;
    left: 20px;
    top: 10px;
    bottom: 20px;
    padding-bottom: 15px;
}
.search-input {
    width: 300px;
}
.task-workers {
    color: #409EFF;
}
</style>
